module.exports = "<div class=\"container container-fluid-blnd\">\n    <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page_header.html
// module id = 508
// module chunks = 0